import React from "react";
import autoBind from "auto-bind";
import { connect } from "../i18n/connect";
import { authNewPasswordInputProps } from "../lib/auth/authAutofillHints";
import withFormBuilder from "./withFormBuilder";
import { resetPasswordExecuteRoutine } from "../redux/modules/resetPassword";
import transformFormData from "../lib/transformFormData";
import firstParam from "../lib/firstParam";

export const getResetPasswordTokenParams = props => {
  const user_id = firstParam(
    props.userId ?? props.user_id ?? props.match?.params?.user_id
  );
  const hash = firstParam(props.hash ?? props.match?.params?.hash);

  return { user_id, hash };
};

export default function withResetPasswordHandler(WrappedComponent) {
  const mapDispatchToProps = {
    executeResetPassword: resetPasswordExecuteRoutine
  };

  const formFields = [
    {
      name: "password",
      value: "",
      type: "newText",
      inputType: "password",
      required: true,
      fullWidth: true,
      validationErrors: {
        isDefaultRequiredValue: "This field is required"
      },
      label: "Password",
      ...authNewPasswordInputProps,
      wrapperClassName: "mb-4 md:mb-6",
      nativeStyles: { marginBottom: 16 }
    },
    {
      name: "password_confirm",
      value: "",
      type: "newText",
      inputType: "password",
      required: true,
      fullWidth: true,
      validations: {
        equalsField: "password"
      },
      validationErrors: {
        equalsField: "Your password doesn't match",
        isDefaultRequiredValue: "This field is required"
      },
      label: "Repeat password",
      ...authNewPasswordInputProps,
      wrapperClassName: "mb-4 md:mb-6",
      nativeStyles: { marginBottom: 16 }
    }
  ];

  @connect(null, mapDispatchToProps)
  @withFormBuilder(formFields)
  class WithResetPasswordHandler extends React.Component {
    state = { resetPasswordData: null };

    constructor(props) {
      super(props);

      autoBind.react(this);
    }

    componentDidMount() {
      this.setState({
        resetPasswordData: getResetPasswordTokenParams(this.props)
      });
    }

    executeResetPassword(formData) {
      const fields = transformFormData(formData);
      const { resetPasswordData } = this.state;

      this.props.executeResetPassword({
        ...fields,
        ...resetPasswordData
      });
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          executeResetPassword={this.executeResetPassword}
        />
      );
    }
  }

  return WithResetPasswordHandler;
}
